exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialogRow[data-v-b83bdfaa] {\n  height: 60vh;\n}\n.confirmBut[data-v-b83bdfaa] {\n  position: absolute;\n  right: 0.260417rem;\n  bottom: 0.130208rem;\n}\n.duedayAlarmForm[data-v-b83bdfaa] {\n  height: 1.276042rem;\n}\n.duedayAlarmForm[data-v-b83bdfaa] .el-input-group {\n  width: calc(100% - 0.15625rem);\n}\n.info-cls[data-v-b83bdfaa] {\n  margin: 0.078125rem 0;\n  text-align: center;\n  font-size: 0.0625rem;\n  color: #fd349c;\n}\n[data-v-b83bdfaa] .el-dialog__body {\n  padding: 0.078125rem;\n}\n[data-v-b83bdfaa] .el-input-group__prepend {\n  width: 0.729167rem;\n}", ""]);

// exports
